/* eslint-disable react/no-danger */
import React, { useState } from 'react';

import {
  GoogleAnalyticsConstants,
  GoogleAnalyticsDisplayedEvent,
  GoogleAnalyticsEventContextWrapper,
} from '@vvoyages/google-analytics';
import DOMPurify from 'isomorphic-dompurify';

import Button from '@/components/Button';
import { BackButton } from '@/components/PredefinedButtons';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';
import DeactivatedInfoModal from './DeactivatedInfoModal';

type ReclaimAccountProps = {
  tabId: string;
  onBackClick: () => void;
  onSubmit: Function;
};

const ReclaimAccount: React.FC<ReclaimAccountProps> = ({ tabId, onBackClick, onSubmit }) => {
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const appUiData = useAppUiData();
  const infoLinkClick = () => {
    setIsInfoVisible(true);
  };
  const handleInfoModalClose = () => {
    setIsInfoVisible(false);
  };
  const subTitle = appUiData[appUiIds.claimBooking.reclaimScreenSubText];
  return (
    <WizardStep tabId={tabId}>
      <GoogleAnalyticsEventContextWrapper category="VV-account-sign-in|claim-a-booking">
        <GoogleAnalyticsDisplayedEvent eventAction={GoogleAnalyticsConstants.EVENT_ACTION.DISPLAYED} />
        <BackButton onClick={onBackClick} className={styles.backButton} />
        <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.title]}</h2>
        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subTitle) }} className={styles.subtitle} />
        <Button onClick={infoLinkClick} className={styles.whyThisHappenedLink}>
          {appUiData[appUiIds.claimBooking.whyThisHappened]}
        </Button>
        <Button className={styles.buttonClaim} variant="payment-card" onClick={onSubmit} disabled={false}>
          {appUiData[appUiIds.claimBooking.title]}
        </Button>
        <Button onClick={onBackClick} className={styles.cancelLink}>
          {appUiData[appUiIds.commonLabels.cancel]}
        </Button>
        <DeactivatedInfoModal isVisible={isInfoVisible} onClose={handleInfoModalClose} />
      </GoogleAnalyticsEventContextWrapper>
    </WizardStep>
  );
};

export default ReclaimAccount;
